export default __webpack_public_path__ + "static/media/Ellipse.fd353ec1.svg";